import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { defectNoticeDetailsSchema } from '../../../common/validations/defectNotice'
import { createBlobUrl } from '../../views/DefectNotice/utils'

import { get } from 'api/apiClient'

const params = (contractUuid: string, uuid: string) => ({
  queryKey: [
    `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/defect-notices/${uuid}`,
  ],
  queryFn: async () => {
    const defectNotice = await get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/defect-notices/${uuid}`,
      defectNoticeDetailsSchema
    )
    const files = await Promise.all(
      (defectNotice.files ?? []).map(async (file) => ({
        ...file,
        url: await createBlobUrl(file.url),
      }))
    )
    return {
      ...defectNotice,
      files,
    }
  },
})

export const useAPIGetDefectNotice = (contractUuid: string, uuid: string) =>
  useQuery(params(contractUuid, uuid))

export const useAPIGetDefectNoticeSuspense = (
  contractUuid: string,
  uuid: string
) => useSuspenseQuery(params(contractUuid, uuid))
